module.exports = __webpack_public_path__ + "static/media/page-screen-right.40aafa07.png";